import { render, staticRenderFns } from "./week_soil_temp.vue?vue&type=template&id=fa471080"
import script from "./week_soil_temp.vue?vue&type=script&lang=js"
export * from "./week_soil_temp.vue?vue&type=script&lang=js"
import style0 from "./week_soil_temp.vue?vue&type=style&index=0&id=fa471080&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports